import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

export const GridContainerStyled = styled(Grid, {
  name: 'GridContainerStyled',
})(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
